import { render, staticRenderFns } from "./checklist-fallback.vue?vue&type=template&id=50306e6c&"
import script from "./checklist-fallback.vue?vue&type=script&lang=js&"
export * from "./checklist-fallback.vue?vue&type=script&lang=js&"
import style0 from "./checklist-fallback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports